import React, { useState } from 'react';
import { useLayout } from 'shared/contexts/LayoutContext';
import { useStateContext } from 'shared/contexts/ContextProvider';
import { notificationTemplateService } from 'features/crm/api';

const NotificationTemplateForm = ({ item, onSuccess, refreshList }) => {
  const { closeModal } = useLayout();
  const { showToast, token } = useStateContext();
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const [itemData, setItemData] = useState(item || {});

  const handleSave = async () => {
    setLoading(true);
    try {
      const data = {
        ...itemData,
      };

      console.log('data', data);
      const response = await notificationTemplateService.save(data, token);
      
      if (response.status === 1) {
        setErrors(response.response || {});
        showToast({
          title: 'Ошибка',
          content: response.message || 'Ошибка валидации',
          type: 'error',
        });
        return;
      }

      showToast({   
        title: 'Успех!',
        content: item ? 'Шаблон уведомления успешно обновлен!' : 'Шаблон уведомления успешно создан!',
        type: 'success',
      });
      
      if (onSuccess) {
        onSuccess(response.response || response);
      }
      refreshList ? refreshList() : null;
      closeModal();
    } catch (error) {
      showToast({
        title: 'Ошибка!',
        content: error.message || 'Что-то пошло не так!',
        type: 'error',
      });
    } finally {
      setLoading(false);
    }
  };

  const handleInputChange = (field, value) => {
    setItemData((prev) => ({ ...prev, [field]: value }));
    if (errors[field]) {
      setErrors((prev) => ({ ...prev, [field]: undefined }));
    }
  };

  const inputClassName = (error) => `
    mt-1 block w-full rounded-md
    ${error 
      ? 'border-red-300 focus:border-red-500 focus:ring-red-500' 
      : 'border-blue-500 ring-gray-100 focus:ring-blue-500'
    }
    transition-colors duration-200
    p-2.5
    ring-2 focus:ring-opacity-50 
    outline-none
  `;

  return (
    <div className='p-8 bg-white'>
      <h2 className='text-2xl font-semibold mb-8 text-gray-800'>
        {item ? 'Редактировать шаблон уведомления' : 'Создать шаблон уведомления'}
      </h2>

      <div className='space-y-6'>
        <div>
          <label className='block text-sm font-medium text-gray-600 mb-1'>
            Заголовок <span className='text-red-500'>*</span>
          </label>
          <input
            type='text'
            className={inputClassName(errors.title)}
            value={itemData.title || ''}
            onChange={(e) => handleInputChange('title', e.target.value)}
          />
          {errors.title && (
            <p className='mt-1.5 text-sm text-red-500'>{errors.title}</p>
          )}
        </div>

        <div>
          <label className='block text-sm font-medium text-gray-600 mb-1'>
            Содержание <span className='text-red-500'>*</span>
          </label>
          <textarea
            className={`${inputClassName(errors.content)} min-h-32`}
            value={itemData.content || ''}
            onChange={(e) => handleInputChange('content', e.target.value)}
            rows={5}
          />
          {errors.content && (
            <p className='mt-1.5 text-sm text-red-500'>{errors.content}</p>
          )}
        </div>

        <div>
          <label className='block text-sm font-medium text-gray-600 mb-1'>
            Ссылка 
          </label>
          <input
            type='text'
            className={`${inputClassName(errors.link)}`}
            value={itemData.link || ''}
            onChange={(e) => handleInputChange('link', e.target.value)}
          />
          {errors.link && (
            <p className='mt-1.5 text-sm text-red-500'>{errors.link}</p>
          )}
        </div>

        <div className='flex justify-end space-x-4 pt-4'>
          <button
            type='button'
            onClick={closeModal}
            className='px-6 py-2.5 border border-gray-200 rounded-md text-gray-700 hover:bg-gray-50 transition-colors duration-200'
          >
            Отмена
          </button>
          <button
            type='button'
            onClick={handleSave}
            disabled={loading}
            className={`px-6 py-2.5 rounded-md text-white transition-colors duration-200 ${
              loading 
                ? 'bg-blue-400 cursor-not-allowed' 
                : 'bg-blue-500 hover:bg-blue-600 active:bg-blue-700'
            }`}
          >
            {loading ? 'Сохранение...' : 'Сохранить'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default NotificationTemplateForm;